export default __webpack_public_path__ + "static/profile-46957932f30090025e4c23f6c709b923.png";